var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MatchDetailFigure"},[(_vm.getUrl(_vm.player) == '')?_c('span',[_c('img',{attrs:{"src":_vm.getImage(_vm.player)}})]):_c('a',{attrs:{"href":_vm.getUrl(_vm.player),"target":"_blank"}},[_c('img',{attrs:{"src":_vm.getImage(_vm.player)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }